<!-- <mat-form-field appearance="outline">
  <mat-label>{{ 'search' | translate }}</mat-label>
  <input matInput placeholder="{{ 'pleaseStartTypingToFilter' | translate }}" #input />
</mat-form-field> -->

<app-ui-input label="{{ 'search' | translate }}" [control]="searchTerm"></app-ui-input>
